export default __webpack_public_path__ + "static/web0-8d9d0c9f3bde0bafcc381ebaa76ba80f.png";